var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ee5050;}.b{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M34.371,16.323a1.563,1.563,0,0,0-1.709-.127l-15.84,8.639a1.579,1.579,0,0,0-.044,2.747l3.74,2.2,8.939-7.449-7.125,8.707V35l3.038-2.362,3.647,2.145a1.579,1.579,0,0,0,2.341-1.011l3.6-15.838a1.561,1.561,0,0,0-.587-1.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.2a463ea76942b76ed68bb1a2c5e6368d.svg";
export { ForwardRef as ReactComponent };